<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="DISEÑO DE ANDEN DE BORDE" />

      <b-row v-if="ready" align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <ValidationObserver ref="mainObserver" v-slot="{ invalid }">
            <b-row class="mb-5">
              <ValidationProvider rules="required" name="Nombre" style="width: 100%" v-slot="{ valid, errors }">
                <p class="configurator-label">
                  <BlankIcon :field="submitalForm.title" />
                  Nombre
                </p>
                <b-input-group size="lg">
                  <b-input
                    v-model="submitalForm.title"
                    type="text"
                    :state="errors[0] ? false : (valid ? true : false)"
                    trim
                    @blur="updateSubmital"
                  />
                </b-input-group>
              </ValidationProvider>
            </b-row>
            <b-row class="mb-5">
              <ValidationProvider :rules="{ required: true, numeric: true, min_value: 1 }" name="cantidad" style="width: 100%" v-slot="{ valid, errors }">
                <p class="configurator-label">Cantidad de equipos idénticos</p>
                <b-input-group size="lg">
                  <b-input
                    v-model.number="submitalForm.quantity"
                    type="number"
                    :state="errors[0] ? false : (valid ? true : false)"
                    min="1"
                    max="100"
                    step="1"
                    @blur="updateSubmital"
                  />
                </b-input-group>
              </ValidationProvider>
            </b-row>
            <b-row class="flex-column">
              <p class="configurator-label">Nivelador de borde (Minidock)</p>
              <b-form-group>
                <b-radio-group size="lg" v-model="form.leveler" stacked class="ml-4">
                  <b-radio value="manual">
                    Nivelador de borde manual
                  </b-radio>
                  <b-radio value="automatico">
                    Nivelador de borde automático
                  </b-radio>
                </b-radio-group>
              </b-form-group>
            </b-row>
            <span class="d-none">{{ invalid }}</span>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import BlankIcon from '../BlankIcon'

export default {
  name: 'Design',
  components: { BlankIcon, ConfiguratorStepTitle, ValidationObserver, ValidationProvider },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      ready: true,
      submitalForm: {
        title: '',
        quantity: ''
      },
      form: {
        leveler: 'manual'
      }
    }
  },
  mounted () {
    if (this.submital) {
      this.submitalForm.title = this.submital.title
      this.submitalForm.quantity = this.submital.quantity
    }
    if (this.anden) {
      this.form.leveler = this.anden.leveler
    }
  },
  computed: {
    ...mapState({
      anden: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    }),
    ...mapGetters(['configuratorStepNumber'])
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable(this.form)
      return result
    },
    updateSubmital () {
      this.submitalForm.quantity = this.submitalForm.quantity > 1 ? this.submitalForm.quantity : 1

      this.$emit('update-submital', this.submitalForm)
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.anden[key])
    }
  }
}
</script>
